import React from 'react';
import './style/Contacts.css';
import NavBar from "./component/NavBar";

function Contacts() {
    return (
        <div className="contacts-page">
            <NavBar />


            <section className="contact-section">
                <h2>Контактная информация</h2>
                <div className="contact-info">
                    <p><strong>Адрес:</strong> г. Ташкент, ул. АвтоМастерская, 123</p>
                    <p><strong>Телефон:</strong> +998 90 000 00 00</p>
                    <p><strong>Email:</strong> info@autoservice.uz</p>
                    <p><strong>Telegram:</strong> @autoservicebot</p>
                </div>

                <div className="map-container">
                    <iframe
                        title="Google Map"
                        src="https://maps.google.com/maps?q=Tashkent&t=&z=13&ie=UTF8&iwloc=&output=embed"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>

            <footer className="footer">
                <p>© 2025 АвтоСервис. Все права защищены.</p>
            </footer>
        </div>
    );
}

export default Contacts;
